module.exports = __webpack_public_path__ + "img/data-1.a0ee2941.png";